/** True when HTML or plain text has visible content. */
export function richTextHasContent(value: string): boolean {
  if (!value?.trim()) return false;
  if (!value.includes('<')) {
    return value.trim().length > 0;
  }
  const text = value
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > 0;
}

/** Load plain text or existing HTML into TipTap. */
export function toWizardEditorHtml(value: string): string {
  if (!value?.trim()) return '<p></p>';
  if (value.trim().startsWith('<')) return value;
  const escaped = value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return escaped
    .split(/\n{2,}/)
    .map((block) => `<p>${block.replace(/\n/g, '<br>')}</p>`)
    .join('');
}

export const WIZARD_FONT_SIZES = [
  { label: 'Small', value: '13px' },
  { label: 'Normal', value: '15px' },
  { label: 'Medium', value: '17px' },
  { label: 'Large', value: '20px' },
] as const;
